<template>
  <div>
    <d-card-header class="border-bottom flex-header">
      <h6 class="m-0">
         <template v-if="isContractAdd">
          Wybierz poręczycieli
        </template>
        <template v-else>
          Poręczyciele
        </template>
      </h6>
      <template v-if="isContractAdd">
        <d-button
          @click.prevent="addNewGuarantor"
          theme="primary">
          <i class="material-icons">add</i> Dodaj poręczyciela
        </d-button>
      </template>
      <template v-if="!isContractAdd">
        <d-button
          v-if="guarantorsList.length > 0 && !isDraft"
          @click.prevent="guarantorsEdit = !guarantorsEdit"
          theme="success">
          <i class="material-icons">edit</i> Edytuj
        </d-button>
        <d-button
          @click.prevent="addNewGuarantor"
          theme="primary">
          <i class="material-icons">add</i> Dodaj
        </d-button>
      </template>
    </d-card-header>
    <d-list-group-item>
      <table class="table mb-0 responsive-table" v-if="scheduleGuarantors">
        <thead class="bg-light">
          <tr>
            <th v-if="guarantorsEdit" scope="col" class="border-0 id-cell"></th>
            <th v-else scope="col" class="border-0 id-cell"></th>
            <th scope="col" class="border-0">Imię i nazwisko</th>
            <th scope="col" class="border-0">Pesel</th>
            <th scope="col" class="border-0">Nr dokumentu tożsamości</th>
            <th scope="col" class="border-0">Egzekucja</th>
            <th scope="col" class="border-0 text-center" style="width: 150px;">Akcje</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(guarantor, index) in scheduleGuarantors" :key="guarantor.id">
            <td>
              <dt></dt>
              <dd v-if="guarantorsEdit">
                <d-checkbox :value="guarantor.id" v-model="guarantorsSelected" />
                </dd>
              <dd v-else>{{ guarantor.id }}</dd>
            </td>
            <td>
              <dt>Imię i nazwisko</dt>
              <dd>
                {{ guarantor.name}} {{ guarantor.surname}}
              </dd>
            </td>
            <td>
              <dt>Pesel</dt>
              <dd>
                {{ guarantor.pesel}}
              </dd>
            </td>
            <td>
              <dt>Nr dokumentu tożsamości</dt>
              <dd>
                {{ guarantor.id_card}}
              </dd>
            </td>
            <td>
              <dt>Egzekucja</dt>
              <dd>
                <div class="execution-inputs">
                  <div class="form-group">
                    <label>Kwota</label>
                    <ss-price-input
                      :disabled="!guarantorsEdit"
                      type="text"
                      name="installment_fee"
                      v-model="guarantor.declaration_amount"/>
                  </div>
                  <div class="form-group">
                    <label>Data</label>
                    <ss-date
                      :disabled="!guarantorsEdit"
                      type="text"
                      name="payment_date"
                      v-model="guarantor.declaration_date"
                      placeholder=""
                      :class="{'disabled is-disabled': !guarantorsEdit}"/>
                  </div>
                  <div class="form-group">
                    <ss-input
                      :disabled="!guarantorsEdit"
                      v-model="guarantor.declaration_doc"
                      name="declaration_doc"
                      label="Dokument"
                      placeholder="Nazwa dokumentu"></ss-input>
                  </div>
                </div>
              </dd>
            </td>
            <td class="text-center">
              <dt>Akcje</dt>
              <dd>
                <template v-if="isContractAdd">
                  <d-button @click.prevent="showGuarantor(guarantor)">
                    <i class="material-icons">visibility</i> Zobacz
                  </d-button>
                </template>
                <template v-else>
                  <d-dropdown>
                    <template slot="button-content">
                      <i class="material-icons">settings</i> Akcje
                    </template>
                    <d-dropdown-item>
                      <p @click.prevent="showGuarantor(guarantor)">
                        <i class="material-icons">visibility</i><span>Zobacz</span>
                      </p>
                    </d-dropdown-item>
                    <d-dropdown-item>
                      <p @click.prevent="editGuarantor(guarantor)">
                        <i class="material-icons">edit</i><span>Edytuj</span>
                      </p>
                    </d-dropdown-item>
                    <d-dropdown-item>
                      <p @click.prevent="removeGuarantor(guarantor)">
                        <i class="material-icons">delete</i><span>Usuń</span>
                      </p>
                    </d-dropdown-item>
                  </d-dropdown>
                </template>
              </dd>
            </td>
          </tr>
          <tr v-if="scheduleGuarantors.length < 1">
            <td
              colspan="6"
              class="text-info text-center">
              Brak poręczycieli do wyświetlenia
            </td>
          </tr>
        </tbody>
      </table>
    </d-list-group-item>

    <guarantor-form-modal
      :is-modal-visible="isGuarantorModalVisible && isGuarantorEdit"
      :selected-guarantor="selectedGuarantor" />

    <guarantor-modal
      :show.sync="isReadonlyModalVisible"
      :props="selectedGuarantor" />
  </div>
</template>

<script>
import ClientUtils from '@/utils/client';
import SsDate from '@/components/common/SsDate';
import SsPriceInput from '@/components/common/SsPriceInput'
import GuarantorModal from '@/components/client/GuarantorModal.vue';
import GuarantorFormModal from '@/components/client/contract-partials/guarantors/GuarantorFormModal.vue';

export default {
  name: 'ContractGuarantors',
  components: {
    SsDate,
    SsPriceInput,
    GuarantorModal,
    GuarantorFormModal
  },
  props: {
    guarantorsList: {
      default: () => [],
      type: Array
    },
    isContractAdd: {
      default: false,
      type: Boolean
    },
    isDraft: {
      required: true,
      type: Boolean
    },
    scheduleGuarantorsList: {
      default: () => [],
      type: Array
    },
    clientId: {
      type: Number,
      default: null
    }
  },
  computed: {
    scheduleGuarantors () {
      if (this.guarantorsEdit) {
        return this.guarantorsList;
      }
      return this.guarantorsList.filter((doc)=> this.guarantorsSelected.find(item => item === doc.id), {});
    },
    selectedGuarantorsFormatted () {
      return this.guarantorsList.filter(guarantor => {
        return this.guarantorsSelected.includes(guarantor.id)
      }, []).map(guarantor => {
        return {
          id: guarantor.id,
          declaration_doc: guarantor.declaration_doc,
          declaration_amount: guarantor.declaration_amount,
          declaration_date: guarantor.declaration_date,
        }
      });
    }
  },
  watch: {
    scheduleGuarantorsList () {
      if (this.isDraft || this.isContractAdd) {
        this.guarantorsEdit = true;
      } else {
        this.guarantorsEdit = false;
      }

      this.guarantorsSelected = this.scheduleGuarantorsList.map(guarantor => guarantor.id, []);
    }
  },
  data () {
    return {
      guarantorsEdit: false,
      guarantorsSelected: [],
      isGuarantorEdit: false,
      isGuarantorModalVisible: false,
      isReadonlyModalVisible: false,
      selectedGuarantor: null
    }
  },
  mounted () {
    this.$bus.$on('guarantor-form-modal-close', this.closeGuarantorModal);
    if (this.isDraft || this.isContractAdd) {
      this.guarantorsEdit = true;
    }

    this.guarantorsSelected = this.scheduleGuarantorsList.map(guarantor => guarantor.id, []);
  },
  methods: {
    showGuarantor (guarantor) {
      this.selectedGuarantor = guarantor;
      this.isGuarantorEdit = false;
      this.isGuarantorModalVisible = false;
      this.isReadonlyModalVisible = true;
    },
    editGuarantor (guarantor) {
      Vue.set(this, 'selectedGuarantor', JSON.parse(JSON.stringify(guarantor)));
      this.isGuarantorEdit = true;

      this.$nextTick(() => {
        this.isGuarantorModalVisible = true;
      });
    },
    addNewGuarantor () {
      const newGuarantor = _.clone(ClientUtils._guarantor);
      if (this.clientId) {
        newGuarantor.client_id = this.clientId;
      }
      Vue.set(this, 'selectedGuarantor', newGuarantor);
      this.isGuarantorEdit = true;

      this.$nextTick(() => {
        this.isGuarantorModalVisible = true;
      })
    },
    removeGuarantor (guarantor) {
      let name = guarantor.name + ' ' + guarantor.surname;

      Vue.swal({
        title: 'Uwaga',
        html: 'Czy potwierdzasz usunięcie<br /><strong>' + name + '</strong><br />z listy poręczycieli? <br /><br /><span class="text-danger">Poręczyciel zostanie również usunięty z karty klienta.</span>',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie',
        buttonsStyling: true
      }).then((result) => {
        if (result.value) {
          axios.post('api/guarantors/remove-guarantor', {
            id: guarantor.id
          }).then(response => {
          if (response.data.cannot_delete && response.data.cannot_delete === 1) {
            Vue.swal({
              type: 'info',
              html: 'By usunąć poręczyciela <strong>' + name + '</strong>,<br /> odepnij go najpierw z&nbsp;umów w&nbsp;których uczestniczy',
              showConfirmButton: true,
            })
          } else {
            Vue.swal({
              type: 'success',
              title: 'Poręczyciel został usunięty.',
              showConfirmButton: true,
            }).then(() => {
              this.$bus.$emit('contract-reload-guarantors');
            });
          }
          }).catch((errors) => {
            console.log(errors);
          })
        }
      }).catch((errors) => {
        console.log(errors);
      })
    },
    closeGuarantorModal (shoudlReload = false) {
      this.isGuarantorModalVisible = false;

      if (shoudlReload) {
        this.$bus.$emit('contract-reload-guarantors');
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('guarantor-form-modal-close', this.closeGuarantorModal);
  }
}
</script>
